import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingTllFormModel } from "@/components/features/settings/site-controller/model/tl-lincoln/type";
import type { SiteControllerSettingTLLincolnFormModelMethodsType } from "@/components/features/settings/site-controller/model/tl-lincoln/use-case/use-create-model/methods";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

type Props = {
	tllID: SiteControllerSettingTllFormModel["ViewModel"]["tll"]["tllID"]; //
	onSetTllID: SiteControllerSettingTLLincolnFormModelMethodsType["siteControllerSettingTLLFormModelMethods"]["onSetTllID"];
};

export const SettingsSiteControllerTllID = ({ tllID, onSetTllID }: Props) => {
	return (
		<QuestionForMain
			required={true}
			title={"TL-リンカーンの6桁の施設ID"}
			inputChildren={
				<InputTextField
					className="w-2/3 lg:w-1/2"
					value={tllID.value}
					errorMessage={tllID.error}
					handleChange={onSetTllID}
				/>
			}
		/>
	);
};

SettingsSiteControllerTllID.displayName = "SettingsSiteControllerTllID";
